<script lang="ts">
  export let onClick: () => void;
  export let classNames: string = "";
</script>

<button
  on:click|preventDefault={onClick}
  class="close-button flex items-center justify-center w-[22px] h-[22px] text-black absolute top-[10px] right-[10px] border-solid border-black border-2 rounded-[50%] transition laptop:w-[24px] desktop:w-[30px] desktopLg:w-[38px] laptop:h-[24px] desktop:h-[30px] desktopLg:h-[38px] {classNames}"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.522 148.52">
    <defs>
      <clipPath id="clip-path">
        <path d="M0 0h148.521v148.52H0z" style="fill:none"/>
      </clipPath>
      <style>.cls-3{fill: currentColor}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1" style="clip-path:url(#clip-path)">
        <path d="M127.493 24.075a3.343 3.343 0 0 0 3.149-1.052 3.634 3.634 0 0 0 .91-1.562c.481.347 1.09 1.209 1.662 1.269a2.628 2.628 0 0 0 2.131-1.311c.284-.568-.104-1.321-.34-1.887l10.238-14.176c.975-1.414 2.41-3.428 3.234-4.831a.391.391 0 0 0-.045-.438.39.39 0 0 0-.435-.041c-1.404.822-3.418 2.256-4.834 3.23l-14.174 10.24c-.566-.237-1.32-.624-1.887-.34a2.627 2.627 0 0 0-1.311 2.13c.059.573.923 1.184 1.269 1.663a3.634 3.634 0 0 0-1.562.91 3.344 3.344 0 0 0-1.049 3.172L21.028 124.446a3.339 3.339 0 0 0-3.148 1.052 3.628 3.628 0 0 0-.91 1.562c-.481-.348-1.091-1.21-1.663-1.27a2.63 2.63 0 0 0-2.13 1.312c-.285.567.103 1.32.339 1.887L3.278 143.165c-.975 1.414-2.409 3.428-3.233 4.83a.39.39 0 0 0 .045.438.386.386 0 0 0 .434.042c1.405-.822 3.418-2.257 4.834-3.23l14.174-10.24c.566.236 1.32.624 1.888.34a2.63 2.63 0 0 0 1.311-2.131c-.06-.572-.924-1.183-1.27-1.662a3.632 3.632 0 0 0 1.563-.91 3.343 3.343 0 0 0 1.048-3.172Z" class="cls-3"/>
        <path d="M21.029 24.075a3.343 3.343 0 0 1-3.15-1.052 3.634 3.634 0 0 1-.91-1.562c-.48.347-1.09 1.209-1.661 1.269a2.628 2.628 0 0 1-2.131-1.311c-.284-.568.104-1.321.34-1.887L3.279 5.356C2.304 3.942.869 1.928.045.525A.391.391 0 0 1 .09.087.39.39 0 0 1 .525.046c1.404.822 3.418 2.256 4.834 3.23l14.174 10.24c.566-.237 1.32-.624 1.887-.34a2.627 2.627 0 0 1 1.31 2.13c-.058.573-.922 1.184-1.268 1.663a3.629 3.629 0 0 1 1.562.91 3.344 3.344 0 0 1 1.049 3.172l103.42 103.395a3.339 3.339 0 0 1 3.149 1.052 3.629 3.629 0 0 1 .91 1.562c.48-.348 1.09-1.21 1.663-1.27a2.63 2.63 0 0 1 2.13 1.312c.285.567-.103 1.32-.34 1.887l10.239 14.176c.975 1.414 2.409 3.428 3.233 4.83a.346.346 0 0 1-.48.48c-1.404-.822-3.417-2.257-4.833-3.23l-14.174-10.24c-.566.236-1.32.624-1.888.34a2.63 2.63 0 0 1-1.311-2.131c.06-.572.924-1.183 1.27-1.662a3.632 3.632 0 0 1-1.563-.91 3.343 3.343 0 0 1-1.048-3.172Z" class="cls-3"/>
      </g>
    </g>
  </svg>
</button>

<style>
  .close-button svg {
    width: 62%;
    stroke-width: 3px;
    stroke: white;
    transition: stroke 0.2s ease-in-out, fill 0.2s ease-in-out;
  }
  
  .close-button:hover {
    border-color: #ff6000;
  }
</style>
